export default __webpack_public_path__ + "static/media/VKOW_11_mos_JLEE.ffc3dd73.wav";